import css from 'styled-jsx/css'

export interface ITimeLine {
  styleType?: ('is-centered' | 'is-rtl' | 'no-headers')[]
  className?: string
}

const ShTimeline: React.FC<ITimeLine> = ({ ...props }) => {
  const styleType = props.styleType || []

  return (
    <>
      <style jsx>{TimelineStyle}</style>
      <div
        className={`timeline ${props.className} ${
          styleType.length ? ` ${props.styleType?.join(' ')}` : ''
        }`}
      >
        {props.children}
      </div>
    </>
  )
}

const TimelineStyle = css.global`
  @-webkit-keyframes spinAround {
    from {
      -webkit-transform: rotate(0);
      transform: rotate(0);
    }

    to {
      -webkit-transform: rotate(359deg);
      transform: rotate(359deg);
    }
  }

  @keyframes spinAround {
    from {
      -webkit-transform: rotate(0);
      transform: rotate(0);
    }

    to {
      -webkit-transform: rotate(359deg);
      transform: rotate(359deg);
    }
  }

  .timeline {
    display: flex;
    flex-direction: column;
    /* Default: Left to right */

    .timeline-header {
      width: 4em;
      min-width: 4em;
      max-width: 8em;
      word-wrap: normal;
      text-align: center;
      display: flex;
      justify-content: center;
    }

    .timeline-item {
      display: flex;
      display: -webkit-flex;
      position: relative;
      margin-left: 2em;
      padding-bottom: 0.5rem;

      &::before {
        content: '';
        background-color: #eaecf0;
        display: block;
        width: 1px;
        height: 110%;
        position: absolute;
        left: -0.5px;
        top: 0.5rem;
      }

      &:last-child {
        padding-bottom: 0;
        &.simple-content::before {
          height: 120%;
        }
        &::before {
          top: 0.75rem;
        }
      }

      .timeline-marker {
        position: absolute;
        background: #c5cdd5;
        border: 1px solid #0b92f1;
        border-radius: 100%;
        content: '';
        display: block;
        height: 12px;
        -webkit-transform: translateX(-45%);
        transform: translateX(-45%);
        top: 6px;
        width: 12px;

        &.default {
          border: 1px solid #c5cdd5;
          width: 6px;
          height: 6px;
          top: 9px;
        }

        &.is-image {
          background: #0b92f1;
          border: 1px solid #0b92f1;
          border-radius: 100%;
          display: block;
          overflow: hidden;

          &.is-16x16 {
            height: 16px;
            width: 16px;
          }

          &.is-24x24 {
            height: 24px;
            width: 24px;
          }

          &.is-32x32 {
            height: 32px;
            width: 32px;
          }

          &.is-48x48 {
            height: 48px;
            width: 48px;
          }

          &.is-64x64 {
            height: 64px;
            width: 64px;
          }

          &.is-96x96 {
            height: 96px;
            width: 96px;
          }

          &.is-128x128 {
            height: 128px;
            width: 128px;
          }
        }

        &.is-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 24px;
          width: 24px;
          background: #d5d5d5;
          border: 1px solid #d5d5d5;
          border-radius: 100%;
          padding: 0.5rem;

          > * {
            font-size: 0.75rem !important;
          }
        }

        &.is-outlined {
          .image {
            background: #ffffff;
          }

          &.is-icon {
            background: #ffffff;

            > * {
              color: #d5d5d5;
            }
          }
        }

        &.is-white {
          background-color: #ffffff !important;
          border-color: #ffffff !important;

          .image {
            border-color: #ffffff !important;
          }

          &.is-icon {
            background-color: #ffffff !important;
            border-color: #ffffff !important;

            > * {
              color: #000000 !important;
            }
          }

          &.is-outlined {
            background-color: #ffffff !important;
            border-color: #ffffff !important;

            .image {
              background-color: #ffffff !important;
            }

            &.is-icon {
              background-color: #ffffff !important;

              > * {
                color: #ffffff !important;
              }
            }
          }
        }

        &.is-black {
          background-color: #000000 !important;
          border-color: #000000 !important;

          .image {
            border-color: #000000 !important;
          }

          &.is-icon {
            background-color: #000000 !important;
            border-color: #000000 !important;

            > * {
              color: #ffffff !important;
            }
          }

          &.is-outlined {
            background-color: #ffffff !important;
            border-color: #000000 !important;

            .image {
              background-color: #ffffff !important;
            }

            &.is-icon {
              background-color: #ffffff !important;

              > * {
                color: #000000 !important;
              }
            }
          }
        }

        &.is-light {
          background-color: #f9fafb !important;
          border-color: #f9fafb !important;

          .image {
            border-color: #f9fafb !important;
          }

          &.is-icon {
            background-color: #f9fafb !important;
            border-color: #f9fafb !important;

            > * {
              color: #363636 !important;
            }
          }

          &.is-outlined {
            background-color: #ffffff !important;
            border-color: #f9fafb !important;

            .image {
              background-color: #ffffff !important;
            }

            &.is-icon {
              background-color: #ffffff !important;

              > * {
                color: #f9fafb !important;
              }
            }
          }
        }

        &.is-dark {
          background-color: #363636 !important;
          border-color: #363636 !important;

          .image {
            border-color: #363636 !important;
          }

          &.is-icon {
            background-color: #363636 !important;
            border-color: #363636 !important;

            > * {
              color: #f9fafb !important;
            }
          }

          &.is-outlined {
            background-color: #ffffff !important;
            border-color: #363636 !important;

            .image {
              background-color: #ffffff !important;
            }

            &.is-icon {
              background-color: #ffffff !important;

              > * {
                color: #363636 !important;
              }
            }
          }
        }

        &.is-primary {
          background-color: #0b92f1 !important;
          border-color: #0b92f1 !important;

          .image {
            border-color: #0b92f1 !important;
          }

          &.is-icon {
            background-color: #0b92f1 !important;
            border-color: #0b92f1 !important;

            > * {
              color: #ffffff !important;
            }
          }

          &.is-outlined {
            background-color: #ffffff !important;
            border-color: #0b92f1 !important;

            .image {
              background-color: #ffffff !important;
            }

            &.is-icon {
              background-color: #ffffff !important;

              > * {
                color: #0b92f1 !important;
              }
            }
          }
        }

        &.is-link {
          background-color: #3273dc !important;
          border-color: #3273dc !important;

          .image {
            border-color: #3273dc !important;
          }

          &.is-icon {
            background-color: #3273dc !important;
            border-color: #3273dc !important;

            > * {
              color: #ffffff !important;
            }
          }

          &.is-outlined {
            background-color: #ffffff !important;
            border-color: #3273dc !important;

            .image {
              background-color: #ffffff !important;
            }

            &.is-icon {
              background-color: #ffffff !important;

              > * {
                color: #3273dc !important;
              }
            }
          }
        }

        &.is-info {
          background-color: #209cee !important;
          border-color: #209cee !important;

          .image {
            border-color: #209cee !important;
          }

          &.is-icon {
            background-color: #209cee !important;
            border-color: #209cee !important;

            > * {
              color: #ffffff !important;
            }
          }

          &.is-outlined {
            background-color: #ffffff !important;
            border-color: #209cee !important;

            .image {
              background-color: #ffffff !important;
            }

            &.is-icon {
              background-color: #ffffff !important;

              > * {
                color: #209cee !important;
              }
            }
          }
        }

        &.is-success {
          background-color: #219653 !important;
          border-color: #219653 !important;

          .image {
            border-color: #219653 !important;
          }

          &.is-icon {
            background-color: #219653 !important;
            border-color: #219653 !important;

            > * {
              color: #ffffff !important;
            }
          }

          &.is-outlined {
            background-color: #ffffff !important;
            border-color: #219653 !important;

            .image {
              background-color: #ffffff !important;
            }

            &.is-icon {
              background-color: #ffffff !important;

              > * {
                color: #219653 !important;
              }
            }
          }
        }

        &.is-warning {
          background-color: #f2994a !important;
          border-color: #f2994a !important;

          .image {
            border-color: #f2994a !important;
          }

          &.is-icon {
            background-color: #f2994a !important;
            border-color: #f2994a !important;

            > * {
              color: rgba(0, 0, 0, 0.7) !important;
            }
          }

          &.is-outlined {
            background-color: #ffffff !important;
            border-color: #f2994a !important;

            .image {
              background-color: #ffffff !important;
            }

            &.is-icon {
              background-color: #ffffff !important;

              > * {
                color: #f2994a !important;
              }
            }
          }
        }

        &.is-danger {
          background-color: #a4262c !important;
          border-color: #a4262c !important;

          .image {
            border-color: #a4262c !important;
          }

          &.is-icon {
            background-color: #a4262c !important;
            border-color: #a4262c !important;

            > * {
              color: #ffffff !important;
            }
          }

          &.is-outlined {
            background-color: #ffffff !important;
            border-color: #a4262c !important;

            .image {
              background-color: #ffffff !important;
            }

            &.is-icon {
              background-color: #ffffff !important;

              > * {
                color: #a4262c !important;
              }
            }
          }
        }
      }

      .timeline-content {
        padding-left: 1rem;
        .heading {
          font-weight: 600;
          font-size: 13px;
        }
      }

      &.is-white::before {
        background-color: #ffffff;
      }

      &.is-black::before {
        background-color: #000000;
      }

      &.is-light::before {
        background-color: #f9fafb;
      }

      &.is-dark::before {
        background-color: #363636;
      }

      &.is-primary::before {
        background-color: #0b92f1;
      }

      &.is-link::before {
        background-color: #3273dc;
      }

      &.is-info::before {
        background-color: #209cee;
      }

      &.is-success::before {
        background-color: #219653;
      }

      &.is-warning::before {
        background-color: #f2994a;
      }

      &.is-danger::before {
        background-color: #a4262c;
      }
    }

    &.is-centered {
      .timeline-header {
        display: flex;
        width: 100%;
        align-self: center;
      }

      .timeline-item {
        width: 50%;
        align-self: flex-end;
        flex-direction: row;

        &:nth-of-type(2n) {
          align-self: flex-start;
          flex-direction: row-reverse;
          margin-left: 0;
          margin-right: 2em;

          &::before {
            right: -0.5px;
            left: auto;
          }

          .timeline-marker {
            -webkit-transform: translateX(45%);
            transform: translateX(45%);
          }

          .timeline-content {
            padding: 1em 2em 0 0;
            text-align: right;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            flex-basis: 100%;
          }
        }

        &:nth-of-type(2n + 1)::before {
          content: '';
          background-color: #d5d5d5;
          display: block;
          width: 1px;
          height: 100%;
          position: absolute;
          top: 0;
        }

        &.is-white::before {
          background-color: #ffffff;
        }

        &.is-black::before {
          background-color: #000000;
        }

        &.is-light::before {
          background-color: #f9fafb;
        }

        &.is-dark::before {
          background-color: #363636;
        }

        &.is-primary::before {
          background-color: #0b92f1;
        }

        &.is-link::before {
          background-color: #3273dc;
        }

        &.is-info::before {
          background-color: #209cee;
        }

        &.is-success::before {
          background-color: #219653;
        }

        &.is-warning::before {
          background-color: #f2994a;
        }

        &.is-danger::before {
          background-color: #a4262c;
        }
      }
    }

    &.is-rtl {
      justify-content: flex-end;
      align-items: flex-end;

      .timeline-item {
        justify-content: flex-end;
        flex-direction: row;
        border-left: none;
        margin-left: 0;
        margin-right: 2em;

        &::before {
          right: 0;
          left: auto;
        }

        .timeline-marker {
          -webkit-transform: translateX(50%);
          transform: translateX(50%);

          &.is-image {
            &.is-16x16,
            &.is-24x24,
            &.is-32x32,
            &.is-48x48,
            &.is-64x64,
            &.is-96x96,
            &.is-128x128 {
              -webkit-transform: translateX(50%);
              transform: translateX(50%);
            }
          }
        }

        .timeline-content {
          padding: 1em 2em 0 0;
          text-align: right;
        }
      }
    }

    &.no-headers .timeline-item {
      &.is-first::before {
        height: calc(100% - 1.2rem);
        top: 1.5rem;
      }

      &.is-last::before {
        height: 1.5rem;
      }
    }
  }
`

export default ShTimeline
